import React, { useState, useEffect, useContext } from "react";
import fetchHook from "../../hooks/fetchMSSQL-hook";
import { NavigationContext } from "../../context/navigation-context";
import SearchFilter from "../../components/Filter/SearchFilter";
import formHook from "../../hooks/form-hook";
import EventForm from "../../components/Modals/EventForm";
import { NotificationManager } from "react-notifications";

export default function Events() {
  const { fetchMssqlApi } = fetchHook();
  const { setHeaderData } = useContext(NavigationContext);
  const { form, openForm, closeForm } = formHook();
  const [events, setEvents] = useState([]);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const defaultFilter = {
    name: "events",
    page: 1,
    rowsPerPage: 50,
    isActive: "true",
    sortBy: "none",
  };

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage =
    settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    Code: "ASC",
    Name: "ASC",
    NotificationType: "ASC",
    Description: "ASC",
    IsActive: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    fetchEvents(next, true);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);

      const reservedSpace = 350;
      const visibleRows = Math.floor(
        (window.innerHeight - reservedSpace) / 40
      );

      setFilter((prev) => ({
        ...prev,
        rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
      }));
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchEvents = (f = filter, force = false) => {
    if (!settingsFilter.autoLoading && !force) return;

    fetchMssqlApi(
      "events",
      {
        method: "GET",
        hideNotification: true,
        params: {
          isActive:
            f?.isActive === "null"
              ? null
              : f?.isActive === "true",
          sortBy: f?.sortBy,
        },
      },
      (res) => setEvents(res || [])
    );
  };

  const search = () => {
    fetchEvents(filter, true);
  };

  useEffect(() => {
    if (settingsFilter.autoLoading) {
      fetchEvents(filter);
    }
  }, [filter]);

  useEffect(() => {
    setHeaderData({ text: "Zdarzenia" });
  }, []);

  const handleSubmit = (evt, data, setData) => {
    evt.preventDefault();

    const submitter = evt.nativeEvent?.submitter;
    const submitterId = submitter?.id || submitter?.name;

    const current = events.find((e) => e.EventId === form);

    if (submitterId === "isActive") {
      if (!current) {
        NotificationManager.warning("Najpierw zapisz zdarzenie");
        return;
      }

      fetchMssqlApi(
        `event/${form}`,
        { method: "PUT", data: { ...current, IsActive: !current.IsActive } },
        () => {
          fetchEvents(filter, true);
          closeForm();
        }
      );
      return;
    }

    const isAvailable =
      events
        .filter((e) => e.EventId !== form)
        .map((e) => e.Code)
        .indexOf((data.Code || "").trim()) === -1;

    if (!isAvailable) {
      setData((prev) => ({ ...prev, Code: "" }));
      NotificationManager.error("Taki kod już istnieje");
      return;
    }

    const { Code, Name, Description, DefaultNotificationLevelId } = data;
    const payload = { Code, Name, Description, DefaultNotificationLevelId };

    if (form === "new") {
      fetchMssqlApi("event", { method: "POST", data: payload }, () => {
        fetchEvents(filter, true);
        closeForm();
      });
    } else if (current) {
      fetchMssqlApi(
        `event/${form}`,
        { method: "PUT", data: { ...payload, IsActive: current.IsActive } },
        () => {
          fetchEvents(filter, true);
          closeForm();
        }
      );
    } else {
      NotificationManager.error("Something went wrong");
    }
  };

  const getCheckboxFromBool = (bool) => (
    <div className="d-flex justify-content-center align-items-center">
      <input type="checkbox" checked={!!bool} readOnly />
    </div>
  );

  const filtered = events.filter(t => {
    if (filter.isActive === "true") return t.IsActive === 1;
    if (filter.isActive === "false") return t.IsActive === 0;
    debugger;
    return true;
  });

  return (
    <div>
      <SearchFilter
        filterName="events"
        defaultFilter={defaultFilter}
        onFilterChange={(f) =>
          setFilter((prev) => ({ ...prev, ...f }))
        }
        onSettingsChange={(s) =>
          setSettingsFilter((prev) => ({ ...prev, ...s }))
        }
        search={search}
        totalCount={events.slice((filter.page - 1) * rowsPerPage, filter.page * rowsPerPage).length}
        dataList={events}
        forNow
      />

      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <div />
          <div
            onClick={openForm("new")}
            className="btn btn-outline-secondary mt-1 mb-1"
          >
            <i className="fas fa-plus" />
          </div>
        </div>

        <div
          className="overflow-auto custom-scroll"
          style={{
            maxHeight: `${windowHeight - 216}px`,
          }}
        >
          {events.length ? (
            <table className="table table-striped">
              <thead>
                <tr className="text-center headers-color">
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("Code")}
                  >
                    Kod{arrow("Code")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("Name")}
                  >
                    Zdarzenie{arrow("Name")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("NotificationType")}
                  >
                    Rodzaj powiadomienia{arrow("NotificationType")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("Description")}
                  >
                    Opis{arrow("Description")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("IsActive")}
                  >
                    Aktywne{arrow("IsActive")}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.slice(
                  (filter.page - 1) * rowsPerPage,
                  filter.page * rowsPerPage
                ).map((event) => (
                  <tr key={event.EventId} className="text-center">
                    <td>{event.Code}</td>
                    <td>{event.Name}</td>
                    <td>{event.NotificationType}</td>
                    <td>{event.Description}</td>
                    <td>{getCheckboxFromBool(event.IsActive)}</td>
                    <td>
                      {event.IsEditable ? (
                        <button
                          onClick={openForm(event.EventId)}
                          className="btn btn-outline-primary btn-sm"
                        >
                          Edytuj
                        </button>
                      ) : "" }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="h3 d-flex justify-content-center align-items-center">
              Brak danych
            </div>
          )}
        </div>

        {form && (
          <EventForm
            handleClose={closeForm}
            handleSubmit={handleSubmit}
            eventData={events.find((e) => e.EventId === form)}
          />
        )}
      </div>
    </div>
  );
}